const Forward10 = () => (
  <>
    <path
      fill="currentColor"
      d="M12 21a7.8 7.8 0 0 0 3.118-.626 8.1 8.1 0 0 0 2.542-1.713 8.1 8.1 0 0 0 1.714-2.543Q20 14.663 20 13a.48.48 0 0 0-.143-.357.48.48 0 0 0-.357-.143.48.48 0 0 0-.357.143A.48.48 0 0 0 19 13q0 2.925-2.038 4.962T12 20t-4.962-2.038T5 13t2.037-4.962T12 6h.38l-1.272 1.273a.488.488 0 0 0 0 .708q.165.165.356.168a.49.49 0 0 0 .357-.162l1.921-1.94a.78.78 0 0 0 .243-.566.77.77 0 0 0-.243-.565l-1.96-1.941a.484.484 0 0 0-.713.006.52.52 0 0 0-.162.354.49.49 0 0 0 .162.354L12.381 5H12a7.8 7.8 0 0 0-3.118.626A8.1 8.1 0 0 0 6.34 7.34a8.1 8.1 0 0 0-1.714 2.542A7.8 7.8 0 0 0 4 13q0 1.663.626 3.118.625 1.455 1.713 2.543a8.1 8.1 0 0 0 2.543 1.713Q10.337 21 12 21"
    />
    <path
      fill="currentColor"
      d="M8.48 11.192h.943v4.058a.43.43 0 0 0 .443.442.43.43 0 0 0 .442-.442v-4.5a.43.43 0 0 0-.442-.442H8.48a.43.43 0 0 0-.442.443.43.43 0 0 0 .442.441"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.692 15.692a.97.97 0 0 1-.712-.287.97.97 0 0 1-.288-.713v-3.384q0-.425.288-.713a.97.97 0 0 1 .712-.287h1.77q.424 0 .712.287.288.288.287.713v3.384q0 .426-.287.713a.97.97 0 0 1-.713.287zm1.654-.884h-1.538q-.116 0-.174-.058t-.057-.173v-3.154q0-.115.057-.173.059-.058.174-.058h1.538q.116 0 .173.058.058.058.058.173v3.154q0 .115-.058.173-.057.058-.173.058"
      clipRule="evenodd"
    />
  </>
)
export default Forward10
